import React from "react"
import { Button } from "antd"
import { AudioOutlined } from "@ant-design/icons"
import { ReactComponent as PhoneOutlined } from "../../../shared/assets/images/PhoneOutlined.svg"
import { ReactComponent as VideoCameraOutlined } from "../../../shared/assets/images/VideoCameraOutlined.svg"
import { ReactComponent as VideoCameraAddOutlined } from "../../../shared/assets/images/VideoCameraAddOutlined.svg"
import { ReactComponent as AudioMutedOutlined } from "../../../shared/assets/images/AudioMutedOutlined.svg"
import { CallControlsProps } from "./types"



export const CallControls: React.FC<CallControlsProps> = ({
    isMicOn,
    isMicStarting,
    isCameraOn,
    isCameraStarting,
    onToggleMicrophone,
    onToggleCamera,
    onEndInterview,
}) => {
    return (
        <div className="absolute z-10 flex items-center gap-4 -translate-x-1/2 bottom-8 left-1/2">
            <Button
                type="primary"
                shape="circle"
                size="large"
                icon={isMicOn ? <AudioOutlined className="w-4 h-4 text-xl" /> : <AudioMutedOutlined className="w-4 h-4 text-xl" />}
                onClick={onToggleMicrophone}
                disabled={isMicStarting}
                className={`flex items-center justify-center border-none w-14 h-14 ${isMicOn ? "bg-gray-800 hover:!bg-gray-700" : "bg-red-300 hover:!bg-red-300"
                    }`}
            />
            <Button
                type="primary"
                shape="circle"
                size="large"
                icon={
                    isCameraOn ? (
                        <VideoCameraOutlined className="w-4 h-4 text-xl" />
                    ) : (
                        <VideoCameraAddOutlined className="w-4 h-4 text-xl" />
                    )
                }
                onClick={onToggleCamera}
                disabled={isCameraStarting}
                className={`flex items-center justify-center border-none w-14 h-14 ${isCameraOn ? "bg-gray-800 hover:!bg-gray-700" : "bg-red-300 hover:!bg-red-300"
                    }`}
            />
            <Button
                type="primary"
                shape="circle"
                size="large"
                danger
                icon={<PhoneOutlined className="w-4 h-4" />}
                onClick={onEndInterview}
                className="flex items-center justify-center !bg-red-700 border-none w-14 h-14 hover:!bg-red-600"
            />
        </div>
    )
}

